import { render, staticRenderFns } from "./DonationsList.vue?vue&type=template&id=2976814e"
import script from "./DonationsList.vue?vue&type=script&lang=js"
export * from "./DonationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports